import React, { useEffect, useRef } from 'react';
import { createRoot, Root } from 'react-dom/client';
import { connect, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import HamburgMenuComp from '../../../components/hamburgmenu';
import BoardService from '../../services/board.service';
import WsDeatailsModal from '../../modals/ws-details';
import BoardSettingsModal from '../../modals/settings';
import BoardConst from '../../utils/constants/board';
import TopMenuConst from '../../../navbar/constants/top_menu.constants';
import { getMenuPermissions, updateMenuPermissions, boardUpdateSharedMembers } from '../../actions/menu.action';
import ConfirmModal from '../../../styled-base/modal/implementations/confirm-modal';
import SharedPopupComp from '../../../components/popup/shared-popup';
import { WbUniqueIdMixin } from '../../../utils/common';
import ImgIconComp from '../../../components/imgcomp';

import WsPermissionModal from '../../modals/index';
import WsPermissionServie from '../../services/wsPermission.service';

const Topmenu = (props: any) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const boardService = new BoardService();
  const wsPermissionService = new WsPermissionServie();

  const [openWsInfo, setOpenWsDetails] = React.useState<any>(null);
  const [openSettings, setOpenSettings] = React.useState<any>(null);
  const [openDeleteBoard, setOpenDeleteBoard] = React.useState<any>(null);
  const menu: any = { mainmenu: 1 };
  const { boardDetails, boardView } = props.board;
  const { isExtern, userPermission, user, board,
    tagId, teamId, tagName } = boardDetails;
  const externalAppName = boardDetails.externalAppName || "";
  menu.items = [];
  const contentId = document.getElementById('content');
  const moveBacklogPopupRoot = useRef<Root>();
  const shareBoardDataRoot = useRef<Root>();

  useEffect(() => {
    dispatch(getMenuPermissions());
  }, []);

  const openPublish = () => {
    return openPublishDialog(boardDetails.tagId, 'board');
  }

  const openWsDetails = async () => {
    const params = { tagId: boardDetails.tagId, teamId: boardDetails.teamId };
    showLoaderWidget(contentId);
    const resp = await boardService.getWsDetails(params);
    removeLoader();
    const { ownerData, response } = resp.data;
    let item = response.data.data;
    item.owner_firstname = ownerData.firstname;
    item.owner_lastname = ownerData.lastname;
    item.owner_picture = ownerData.picture;
    item.owner_timezone = ownerData.timezone ?? 'UTC';
    //console.log('response', item);
    setOpenWsDetails(item);
  }

  const boardSettings = () => {
    setOpenSettings(true);
  }

  const setUserPermissions = async () => {
    const url = `${wbConfig.baseUrl}/activity/WsPermissionUserList`;
    showLoaderWidget(contentId);
    let resp = await wsPermissionService.getWsDetails(teamId, tagId);
    const data = resp.data.data;
    removeLoader();
    WsPermissionModal(data);
    //return openWsUserPermission(teamId, tagId, tagName, url);
  }

  const setMoveWorkstream = () => {
    const url = `${wbConfig.baseUrl}/activity/wsCopyList`;
    return moveCopyWs(teamId, tagId, tagName, url, 1);
  }

  const setCopyWorkstream = () => {
    const url = `${wbConfig.baseUrl}/activity/wsCopyList`;
    return moveCopyWs(teamId, tagId, tagName, url, 0);
  }

  const setCloseWorkstream = () => closeReopenWs(tagId, "now");
  const setReopenWorkstream = () => closeReopenWs(tagId, "");
  const setArchiveWorkstream = () => archiveWs(tagId);
  const setUnArchiveWorkstream = () => unArchiveWs(tagId, teamId);
  const setDeleteWorkstream = () => deleteWorkstreamDialog(tagId);
  const setWorkstreamToRBR = (item: any) => {
    let userPermissionData: any = {};
    if (item.myRbr) {
      userPermissionData.selfRbrAdd = false;
    }
    if (item.managerRbr) {
      userPermissionData.managerRbrAdd = false;
    }
    dispatch(updateMenuPermissions(userPermissionData));
    return addWsToRbrFn(user.id, tagId, undefined, "no");
  }

  const setMoveBackLog = () => {
    const wsId = boardDetails.tagId;
    $.ajax({
      url: `${wbConfig.baseUrl}/board/viewWsList`,
      type: "get"
    }).done(response => {
      if (response.status == "success") {
        let wsList = response.viewWsList;
        // remove current ws from list.
        if (response.viewWsList) {
          const newWsJsonUpd = response.viewWsList.filter(
            (curIte: any) => curIte.id != wsId
          );
          wsList = newWsJsonUpd;
        }
        $(".wsBoardWrapper .wspopupmenu-wrapper").hide();
        ($(moveBacklogPopup) as any).dialog("open");
        if (document.getElementById('move-backlog-popup')) {
          moveBacklogPopupRoot.current?.unmount();
        }
        moveBacklogPopupRoot.current = createRoot(document.getElementById('move-backlog-popup'));
        moveBacklogPopupRoot.current.render(viewMoveBacklogPopup());
        setTimeout(() => registerWsAutoComplete(wsList), 100);
      }
    });
  };

  const viewMoveBacklogPopup = () => {
    return (
      <div className="wsBoardMoveBacklogContainer">
        <input type="hidden" id="newBoardVal" />
        <input type="hidden" id="newTeamVal" />
        <div className="wsBoardMoveBacklogHeadingDiv">
          <div className="wsBoardMoveBacklogHeading">
            <span className="wsBoardBacklogColName">
              {t('workstream.moveItems', { columnTitle: boardDetails.columns[0].title })}
            </span>
          </div>
          <div
            className="wsBoardMoveBacklogCancel clickable"
            onClick={closeMoveBacklogModalBox}
          >
            <ImgIconComp id="close" width="10" height="10" />
          </div>
        </div>
        <div className="wsBoardMoveBacklogBodyText">
          <div className="wsBoardMoveBacklogError">
          {t('Please select workstream')}
          </div>
          <span className="wsBoardBacklogColName">
          {t('workstream.moveAllItems', { columnTitle: boardDetails.columns[0].title })}
          </span>
        </div>
        <div className="wsBoardMoveBacklogINput">
          <input
            type="text"
            className="wsBoardWsSelectionEditor"
            placeholder={t("Enter a workstream name to move items to")}
          />
        </div>
        <div className="wsBoardMoveBacklogSubmitDiv">
          <div
            className="gbl-btn gbl-btn-slim wsBoardMoveBacklogSubmit"
            onClick={moveBacklogItems}
          >
            {t("Move")}
          </div>
        </div>
      </div>
    )
  }
  const registerWsAutoComplete = (wsData: any) => {
    ($(".wsBoardWsSelectionEditor") as any)
      .autocomplete({
        source(request: any, response: any) {
          const term = extractLastTag(request.term.trim());
          const matcher = new RegExp(($ as any).ui.autocomplete.escapeRegex(term), "i");
          response($.grep(wsData, (item: any) => matcher.test(item.name)));
        },
        select(event: any, ui: any) {
          ($(".wsBoardMoveBacklogContainer") as any)
            .find("#newBoardVal")
            .val(ui.item.id);
          ($(".wsBoardMoveBacklogContainer") as any)
            .find("#newTeamVal")
            .val(ui.item.tid);
          ($(".wsBoardMoveBacklogContainer") as any)
            .find(".wsBoardMoveBacklogError")
            .hide();
        },
        open(event: any, ui: any) {
          ($(this) as any)
            .data("ui-autocomplete")
            .menu.element.addClass("wsBoard-ws-list-autocomplete");
        }
      })
      .data("ui-autocomplete")._renderMenu = function (ul: any, items: any) {
        const self = this;
        let currentCategory = "";
        ul.addClass("wsListSuggestClass");
        ul.addClass("clickable");
        $.each(items, (index, item) => {
          if (item.tname != currentCategory) {
            ul.append(
              `<li class=\"ui-autocomplete-tname \">${item.tname}</li>`
            );
            currentCategory = item.tname;
          }
          ($(".wsBoardWsSelectionEditor") as any).data("ui-autocomplete")._renderItemData(ul, item);
        });
      };
  }
  const closeMoveBacklogModalBox = () => {
    ($(moveBacklogPopup) as any).dialog("close");
  }
  const moveBacklogItems = () => {
    const oldBoardVal = boardDetails.tagId;
    const oldTeamVal = boardDetails.teamId;
    const newBoardVal = $(".wsBoardMoveBacklogContainer")
      .find("#newBoardVal")
      .val();
    if (typeof newBoardVal === "undefined" || newBoardVal == "") {
      $(".wsBoardMoveBacklogContainer")
        .find(".wsBoardMoveBacklogError")
        .show();
      return;
    }
    const newTeamVal = $(".wsBoardMoveBacklogContainer")
      .find("#newTeamVal")
      .val();
    $.post(
      `${wbConfig.baseUrl}/board/moveBacklog`,
      {
        newBoardVal,
        teamVal: newTeamVal,
        oldBoardVal,
        oldTeamVal
      },
      (response, status) => {
        if (status == "success") {
          ($(moveBacklogPopup) as any).dialog("close");
          ($(".workstreamactivities") as any).tabs("load", 0);
        }
      }
    );
  }
  const extractLastTag = (term: string) => {
    return term.split(/\s,\s*/).pop();
  }

  const saveSharedBoard = (data: any, obj: any) => {
    if (Object.keys(data).length) {
      data.share_type = data.board_type;
      $.post(`${wbConfig.baseUrl}/board/saveSharedBoard`, data, resp => {
        if (resp.data) {
          updateLeftMenuData("board", resp.data.id, "board", "update", {
            share_type: resp.data.share_type
          });
        }
        if (typeof obj.state.members !== "undefined") {
          dispatch(boardUpdateSharedMembers(data));
        }
        if (typeof obj.closeShareBoard === "function") {
          obj.closeShareBoard.apply(null);
        }
      });
    }
  }

  const shareBoard = () => {
    showLoaderWidget(($("#content") as any));
    const boardId = boardDetails.board.id;
    $.get(
      `${wbConfig.baseUrl}/board/sharedBoardList`,
      { id: boardId },
      resp => {
        removeLoader();
        const sharedMembers = resp.sharedMembers || [];
        const orgUsers = resp.org_users || [];
        ($(shareBoardDatapopUp) as any).dialog("open");
        if (document.getElementById('shareBoardData')) {
          shareBoardDataRoot.current?.unmount();
        }
        shareBoardDataRoot.current = createRoot(document.getElementById('shareBoardData'));
        shareBoardDataRoot.current.render(
          <SharedPopupComp
            key={WbUniqueIdMixin.randomId("share_popup")}
            item={boardDetails.board}
            sharedType={boardDetails.board.share_type}
            orgUsers={orgUsers}
            sharedMembers={sharedMembers}
            type_org={BoardConst.BOARD_TYPE_ORG}
            type_shared={BoardConst.BOARD_TYPE_SHARED}
            saveCallback={saveSharedBoard}
          />,
        );
      }
    );

  };

  const removeBoard = async () => {
    showLoaderWidget($("#content"));
    const response = await boardService.removeBoard({ user_id: user.id, id: board.id });
    if (response.data.status === 'success') {
      renderLeftMenu("board");
      window.location.replace(`${wbConfig.baseUrl}/board/fullBoard`);
      removeLoader();
    }
  };

  const deleteBoardPopup = () => setOpenDeleteBoard(true);

  const deleteBoard = async () => {
    setOpenDeleteBoard(false);
    showLoaderWidget($("#content"));
    const catchResponse = await boardService.deleteBoard({ user_id: user.id, id: board.id });
    if (catchResponse.data.status == "success") {
      updateLeftMenuData("board", board.id, "board", "delete");
      window.location.replace(`${wbConfig.baseUrl}/board/fullBoard`);
      topmenuDeleteObject(TopMenuConst.OBJECT_TYPE_BOARD, board.id, "recent_board");
      removeLoader();
    }
  }

  const saveCallback = (wsId: any) => {
    triggerLeftMenu(
      `${wbConfig.baseUrl}/activity/workstreams?id=${wsId}`,
      false,
      "menu-wb-workstreams"
    );
  }

  const syncWsImport = () => {
    ($(".wsBoardTopMenuDiv .wspopupmenu-wrapper") as any).hide();
    const wsId = boardDetails.tagId;
    wsImportSyncData(wsId);
  }

  if (boardView == BoardConst.BOARD_VIEW_ACTIVITY) {
    menu.items.push({
      title: t("Publish"),
      handler: openPublish,
      class: "publishTeamBoard",
      pic: "publish_img_board",
      width: "23",
      height: "23"
    });
    menu.items.push({
      title: t("Workstream Attributes"),
      handler: openWsDetails,
      class: "ws_attributes",
      pic: "ws_attributes",
      submenu: "",
      width: "21",
      height: "23"
    });
  }
  menu.items.push({
    title: t("Workstream Settings"),
    handler: boardSettings,
    class: "personalize",
    pic: "themes",
    width: "25",
    height: "25"
  });
  if (boardView == BoardConst.BOARD_VIEW_ACTIVITY) {
    if (userPermission.delete && isExtern == 1 && externalAppName != "") {
      menu.items.push({
        title: t('Sync with {{externalAppName}}', { externalAppName }),
        handler: syncWsImport,
        class: "personalize",
        pic: "ws_sync"
      });
    }
    if (userPermission.usrPerm) {
      menu.items.push({
        title: t("User Permissions"),
        handler: setUserPermissions,
        class: "",
        pic: "user_permissions",
        width: "23",
        height: "23"
      });
    }
    const manageWsLifecycle = [];
    if (userPermission.move) {
      manageWsLifecycle.push({
        title: t("Move Workstream"),
        handler: setMoveWorkstream,
        class: "",
        pic: "move_img",
        width: "20",
        height: "20"
      });
    }
    if (userPermission.copy) {
      manageWsLifecycle.push({
        title: t("Copy Workstream"),
        handler: setCopyWorkstream,
        class: "",
        pic: "copy_img",
        width: "20",
        height: "20"
      });
    }
    if (userPermission.close) {
      manageWsLifecycle.push({
        title: t("Close Workstream"),
        handler: setCloseWorkstream,
        class: "",
        pic: "close_img",
        width: "20",
        height: "20"
      });
    } else if (userPermission.reopen) {
      manageWsLifecycle.push({
        title: t("Reopen Workstream"),
        handler: setReopenWorkstream,
        class: "",
        pic: "reopen_img",
        width: "15",
        height: "15"
      });
    }
    if (userPermission.archive) {
      manageWsLifecycle.push({
        title: t("Archive Workstream"),
        handler: setArchiveWorkstream,
        class: "",
        pic: "archive_img",
        width: "20",
        height: "20"
      });
    } else if (userPermission.unarchive) {
      manageWsLifecycle.push({
        title: t("Unarchive Workstream"),
        handler: setUnArchiveWorkstream,
        class: "",
        pic: "archive_img",
        width: "20",
        height: "20"
      });
    }

    if (userPermission.delete) {
      manageWsLifecycle.push({
        title: t("Delete Workstream"),
        handler: setDeleteWorkstream,
        class: "",
        pic: "delete_img",
        width: "20",
        height: "20"
      });
    }
    if (manageWsLifecycle.length > 0) {
      menu.items.push({
        title: t("Workstream Actions"),
        handler: "undefined",
        class: "",
        pic: "manage_lifecycle",
        submenu: manageWsLifecycle,
        width: "25",
        height: "25"
      });
    }
    const addWsTo = [];
    if (userPermission.selfRbrAdd) {
      addWsTo.push({
        title: t("Biz Review"),
        handler: setWorkstreamToRBR,
        class: "wsBoardAddToRbr",
        pic: "rbr_add_img",
        item: { myRbr: 1 },
        width: "25",
        height: "25"
      });
    }
    if (userPermission.managerRbrAdd) {
      addWsTo.push({
        title: t('{{teamManagerName}}\'s Biz Review', { teamManagerName: boardDetails.teamManagerName }),
        handler: setWorkstreamToRBR,
        class: "wsBoardAddToRbr",
        pic: "rbr_add_img",
        item: { managerRbr: 1 },
        width: "25",
        height: "25"
      });
    }
    if (addWsTo.length > 0) {
      /*
        menu.items.push({
          title: "Add Workstream to…",
          handler: "undefined",
          class: "",
          pic: "add_to",
          submenu: addWsTo,
          width: "25",
          height: "25"
        });
      */
    }
    if (
      boardView == BoardConst.BOARD_VIEW_ACTIVITY &&
      boardDetails.boardType == BoardConst.WS_BOARD_TYPE_PROGRESS
    ) {
      // Normal board , Progress bord then
      if (
        userPermission.moveBacklog &&
        boardDetails.columns[0].visible != "on" &&
        //this.state.pauseCnt > 0 &&
        boardDetails.teamId
      ) {
        menu.items.push({
          title: t('Move {{columnTitle}}', { columnTitle: boardDetails.columns[0].title }),
          handler: setMoveBackLog,
          class: "wsBoardMoveBacklog",
          pic: "move_backlog_img",
          width: "25",
          height: "25"
        });
      }
    }
  }

  if (boardView == BoardConst.BOARD_VIEW_SHARED) {
    if (user.id == board.owner) {
      menu.items.push({
        title: t("Share"),
        handler: shareBoard,
        class: "",
        pic: "share_rbr"
      });
    }
    if (user.id != board.owner) {
      menu.items.push({
        title: t("Remove myself"),
        handler: removeBoard,
        class: "",
        pic: "removefromtray_img"
      });
    }
    if (user.id == board.owner) {
      menu.items.push({
        title: t("Delete"),
        handler: deleteBoardPopup,
        class: "",
        pic: "delete_img"
      });
    }
  }
  return (
    <>
      <HamburgMenuComp
        key={Math.random() * 1000}
        menu={menu}
        source="board_top_menu"
      />
      {
        openWsInfo ?
          <WsDeatailsModal
            item={openWsInfo}
            onClose={() => setOpenWsDetails(null)}
            saveCallback={saveCallback}
          />
          : ''
      }
      {
        openSettings ?
          <BoardSettingsModal
            boardDetails={boardDetails}
            boardView={boardView}
            onClose={() => setOpenSettings(false)}
          />
          : ''
      }
      {
        openDeleteBoard ?
          <ConfirmModal
            acceptText={t("Yes")}
            declineText={t("Cancel")}
            title={t("Confirm Deletion")}
            onDecline={() => setOpenDeleteBoard(false)}
            onAccept={deleteBoard}
          >
            <div>
              {t("Are you sure you want to delete the board")}?
            </div>
          </ConfirmModal>
          : ''
      }
    </>
  )
}

const mapsToProps = (state: any) => ({
  board: state
});

export default connect(mapsToProps, null)(Topmenu);
